"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @hidden
 */

var _XTreeNode =
/** @class */
function () {
  /* ---------------------------------------------------------
      CONSTRUCTORS
  --------------------------------------------------------- */
  function _XTreeNode(value, color) {
    this.value = value;
    this.color = color;
    this.parent = null;
    this.left = null;
    this.right = null;
  }

  Object.defineProperty(_XTreeNode.prototype, "grand", {
    get: function get() {
      return this.parent.parent;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(_XTreeNode.prototype, "sibling", {
    get: function get() {
      if (this === this.parent.left) return this.parent.right;else return this.parent.left;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(_XTreeNode.prototype, "uncle", {
    get: function get() {
      return this.parent.sibling;
    },
    enumerable: true,
    configurable: true
  });
  return _XTreeNode;
}();

exports._XTreeNode = _XTreeNode;